import gsap, { Power2 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import InitHeroScroll from "./hero-scroll-animation";

import { preloadZeroImages } from "./zero-fees-animation";

gsap.registerPlugin(ScrollTrigger);

const heroTl = gsap.timeline({ paused: true });

let heroLines = null;

if (window.matchMedia("(max-width: 640px)").matches) {
  heroLines = document.querySelectorAll(".hero__heading--mobile .hero__heading__line");
} else {
  heroLines = document.querySelectorAll(".hero__heading--desktop .hero__heading__line");
}

heroLines.forEach((line, index) => {
  heroTl.fromTo(
    line,
    {
      opacity: 0,
      y: "100%",
    },
    {
      opacity: 1,
      y: 0,
      duration: 0.75,
      delay: 1 + index * 0.2,
      // ease: Power2.easeInOut,
    },
    0
  );
});

// heroTl.fromTo(".hero-animation canvas", { opacity: 0, y: 100 }, { opacity: 1, y: 0, duration: 0.75, delay: 2 }, 0);

heroTl.fromTo(
  ".nav",
  {
    y: "-1.25rem",
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    duration: 0.5,
    // delay: 3,
    delay: 1.7 + heroLines.length * 0.1,
  },
  0
);

document.querySelectorAll("html, body").forEach((item) => {
  item.scrollTop = 0;
});

let scrollBarWidth = window.innerWidth - document.body.offsetWidth;

const disableScroll = () => {
  document.body.classList.add("noscroll");
  document.body.style.paddingRight = scrollBarWidth + "px";
};

disableScroll();

const enableScroll = () => {
  document.body.classList.remove("noscroll");
  document.body.style.paddingRight = "0px";
};

const canvas = document.querySelector(".hero-animation canvas");
const context = canvas.getContext("2d");

canvas.width = 1920;
canvas.height = 1080;

const img = new Image();

const currentFrame = (index) => `img/jpg-sequence/hero/intro-${index.toString().padStart(5, "0")}.jpg`;

img.src = currentFrame(0);

img.onload = function () {
  context.drawImage(img, 0, 0);
};

const updateImage = (index) => {
  img.src = currentFrame(index);
};

let frameCount = 137;
let startAt = 60;

const initialAnimation = () => {
  var currentImage = 0;

  // console.log("ayo, initial animation, less goooo");

  var interval = window.setInterval(function () {
    if (currentImage < startAt) {
      currentImage += 1;
      // console.log("yes yes, should show image: ", currentImage);
    } else {
      window.clearInterval(interval);
      enableScroll();
      InitHeroScroll();
    }
    updateImage(currentImage);
  }, 50);
};

var imagesLoaded = 0;
var images = [];

const preloaderBar = document.querySelector(".preloader__bar");

const preloadImages = () => {
  for (let i = 0; i <= frameCount; i++) {
    let img = new Image();
    img.src = currentFrame(i);
    images.push(img);

    img.onload = function () {
      imagesLoaded += 1;

      if (imagesLoaded <= startAt) {
        let percentage = parseInt((imagesLoaded / startAt) * 100);
        preloaderBar.style.width = percentage + "%";
      }

      // console.log("images: ", imagesLoaded);

      if (imagesLoaded == startAt) {
        gsap.to(".preloader", {
          opacity: 0,
          duration: 0.3,
          onComplete: () => {
            document.querySelector(".preloader").remove();
            document.querySelector(".page-content").classList.add("loaded");
            initialAnimation();
            heroTl.play();
          },
        });
      }

      if (imagesLoaded === frameCount) {
        preloadZeroImages();
        // console.log("done loading initial images");
      }
    };
  }
};

// initialAnimation();

// gsap.to(".preloader", {
//   opacity: 0,
//   duration: 0.3,
//   onComplete: () => {
//     document.querySelector(".preloader").remove();
//     document.querySelector(".page-content").classList.add("loaded");
//     InitHeroScroll();
//     heroTl.play();
//     // enableScroll();
//   },
// });

preloadImages();
